<template>
  <section>
    <!-- Componentes externos -->
    <AprobarCas />
    <VerReporte />
    <h3 class="primary--text">
      <v-icon color="primary">group</v-icon> Lista Personal CAS
    </h3>
    <!-- Boton filtro -->
    <v-btn            
                color="rgb(77,179,88)"
                dark
                title="Ver reporte del CAS / ASP-B"
                type="submit"
                @click.prevent="verReporte()"
              >
                <v-icon>description</v-icon>
              </v-btn>
    <v-tooltip bottom>
      <v-btn
        @click.native="
          () => {
            filterShow = filterShow ? false : true;
          }
        "
        class="btn-refresh"
        slot="activator"
        ><v-icon>filter_list</v-icon>
      </v-btn>
      <span>Búsqueda/filtros</span>
    </v-tooltip>
    <!-- Boton actualizar -->
    <v-tooltip bottom>
      <v-btn
        @click.native="crearActualizarIncrementoSalarial()"
        class="btn-refresh"
        slot="activator"
        ><v-icon>refresh</v-icon>
      </v-btn>
      <span>{{ $t("common.updateList") }}</span>
    </v-tooltip>
    <v-flex xs12>
      <transition name="slide-fade">
        <div class="filter-container" v-show="filterShow">
          <v-icon small color="primary">search</v-icon>

          <div class="filter-item">
            <v-text-field
              label="Nro. ítem"
              v-model="form.nro_item"
              @input="filterNroItem(form.nro_item)"
              type="number"
            ></v-text-field>
          </div>

          <div class="filter-item">
            <v-text-field
              label="Nombres"
              
              v-model="form.nombres"
              @input="filterNombres(form.nombres)"
            ></v-text-field>
          </div>

          <div class="filter-item">
            <v-text-field
              label="Ap. paterno"
              
              v-model="form.ap_paterno"
              @input="filterApPaterno(form.ap_paterno)"
            ></v-text-field>
          </div>

          <div class="filter-item">
            <v-text-field
              label="Ap. Materno"
              v-model="form.ap_materno"
              
              @input="filterApMaterno(form.ap_materno)"
            ></v-text-field>
          </div>
          <div class="filter-item">
            <v-text-field
              label="Fecha presentación en ASP-B"
              type="date"
              v-model="form.fecha_presentacion"
             
              @input="filterFechaPresentacion(form.fecha_presentacion)"
            ></v-text-field>
          </div>
          <div class="filter-item">
            <v-text-field
              label="Fecha trámite CAS"
              type="date"
              v-model="form.fecha_tramite"
              @input="filterFechaTramite(form.fecha_tramite)"
            ></v-text-field>
          </div>
          <div class="filter-item">
            <v-text-field
              label="Años de calificación a la fecha"
              v-model="form.anios"
              type="number"
              @input="filterAnios(form.anios)"
            ></v-text-field>
          </div>
          <div class="filter-item">
            <v-text-field
              label="Meses de calificación a la fecha"
              v-model="form.meses"
              type="number"
              @input="filterMeses(form.meses)"
            ></v-text-field>
          </div>
          <div class="filter-item">
            <v-text-field
              label="Días calificados a la fecha"
              v-model="form.dias"
              type="number"
              @input="filterDias(form.dias)"
            ></v-text-field>
          </div>
          <div class="filter-item">
            <v-text-field
              label="Estado"
              v-model="form.estado"
              @input="filterEstado(form.estado)"
            ></v-text-field>
          </div>

          <!-- botones cerrar -->
          <div class="btn-filter">
            <v-tooltip bottom>
              <v-btn icon small slot="activator" @click.native="recargar()">
                <v-icon small>refresh</v-icon>
              </v-btn>
              <span>Recargar filtros</span>
            </v-tooltip>
            <v-tooltip bottom>
              <v-btn
                icon
                slot="activator"
                @click.native="
                  () => {
                    filterShow = false;
                    recargar();
                  }
                "
              >
                <v-icon>close</v-icon>
              </v-btn>
              <span>Cerrar filtros</span>
            </v-tooltip>
          </div>
        </div>
      </transition>
    </v-flex>
    <v-card>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="lista_cas"
          class="elevation-1"
          :no-data-text="loading ? 'Cargando...' : 'No se tiene registros'"
          :disable-initial-sort="true"
          :loading="loading"
          no-results-text="No se encontraron coincidencias"
          item-key="index"
          :search="filters"
          :custom-filter="customFilter"
          :rows-per-page-items="[20, 40, { text: 'Todos', value: -1 }]"
        >
          <!-- Template de filas y columnas -->
          <template slot="items" slot-scope="items">
            <!-- Agregar las columnas que consideré necesarias -->
            <td class="text-xs-center">{{ items.item.nro_item }}</td>
            <td class="text-xs-center">{{ items.item.nombres }}</td>
            <td class="text-xs-center">{{ items.item.ap_paterno }}</td>
            <td class="text-xs-center">{{ items.item.ap_materno }}</td>
            <td class="text-xs-center">
              {{ items.item.fecha_presentacion }}
            </td>
            <td class="text-xs-center">
              {{ items.item.fecha_tramite }}
            </td>

            <td class="text-xs-center">
              {{ items.item.anios }}
            </td>
            <td class="text-xs-center">
              {{ items.item.meses }}
            </td>
            <td class="text-xs-center">
              {{ items.item.dias }}
            </td>
            <td class="text-xs-center">
              {{ items.item.id_estado == 1 ? " " : items.item.estado }}
            </td>
            <td class="nowrap text-xs-center">
              <v-tooltip bottom>
                <v-btn
                  icon
                  v-if="items.item.id_estado == 1"
                  color="rgb(147,13,242)"
                  dark
                  slot="activator"
                  @click.native="aprobarCas(items.item)"
                >
                  <v-icon>done</v-icon>
                </v-btn>
                <span>Aprobar CAS</span>
              </v-tooltip>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import CrudTable from "@/common/util/crud-table/CrudTable.vue"; // Componente Tabla Dinámica
import crud from "@/common/util/crud-table/mixins/crud-table"; // Funciones y Metodos
import AprobarCas from "./dialogs/AprobarCas.vue";
import VerReporte from "./dialogs/VerReporte.vue";
import Filtros from "./mixins/filtros";

export default {
  // Importación de métodos y funciones de un archivo mixin
  mixins: [crud, Filtros],
  // Variables iniciales del componente
  data() {
    return {

      graphql: true,
      lista_cas: [],
      loading: false,
      form: {},
      // Variables filtros
      filters: {
        nro_item: "",
        nombres: "",
        ap_paterno: "",
        ap_materno: "",
        fecha_presentacion: "",
        fecha_tramite: "",
        anios: "",
        meses: "",
        dias: "",
        estado: "",
      },
      filterShow: true,
      // Cabecera de la tabla
      headers: [
        { text: "Ítem", value: "item", align: "center" },
        { text: "Nombres", value: "nombres", align: "center" },
        { text: "Ap. paterno", value: "ap_paterno", align: "center" },
        { text: "Ap. materno", value: "ap_materno", align: "center" },
        {
          text: "Fecha presentación en ASP-B",
          value: "fecha_presentacion",
          align: "center",
        },
        {
          text: "Fecha trámite CAS",
          value: "fecha_tramite",
          align: "center",
        },
        {
          text: "Años de calificación a la fecha",
          value: "anios",
          align: "center",
        },
        {
          text: "Meses de calificación a la fecha",
          value: "meses",
          align: "center",
        },
        { text: "Días calificados a la fecha", value: "dias", align: "center" },
        { text: "Estado", value: "estado", align: "center" },
        { text: this.$t("common.actions"), sortable: false, align: "center" },
      ],
    };
  },
  // Funcionalidades que se ejecutan al montar el componente
  async mounted() {
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [0]; // ID's de roles permitidos
    await this.cargarCas();
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push("/403");
    }

    this.$bus.$on("closeDialogAprobarCas", async () => {
      await this.cargarCas();
    });
  },
  // Métodos y funciones del componente
  methods: {
    aprobarCas(item) {
      this.$bus.$emit("openDialogAprobarCas", item);
    },
    verReporte(){
      let url;
      let nombre_reporte = "rpt_cas";
      let formato_doc = "output=xls";
      let nombre_carpeta = "persona";
      let url_carpeta = process.env.REPORTE_URL_OFICIAL.replace(
        /{carpeta}/g,
        nombre_carpeta
      );
      url = `${url_carpeta}${nombre_reporte}&${formato_doc}`;
      window.open(url);
      // URL con parametros

      console.log("es ", url);
     // this.$bus.$emit("openDialogVerReporteCAS", url);
    },
    async cargarCas() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
               query {
                  runQuery(consulta:"select * from persona.v_persona_cas vip where vip.id_estado<>2 order by vip.nro_item"){
                    respuesta
                  }
                }
              `,
        });
        this.lista_cas = respuesta.runQuery.respuesta;
      } catch (error) {
        console.log(error);
      }
    },
  },
  // Definición de componentes importados
  components: {
    CrudTable,
    AprobarCas,
    VerReporte,
  },
};
</script>

<style lang="scss">
$filterBackground: #e1f5f0;
$filterBorder: #e5e5e5;
#cabecera_tabla {
  background: #007dbb;
  font-weight: bold;
  color: white;
}
.filter-container {
  background-color: $filterBackground;
  padding: 10px 15px 20px;
  border: 1px solid $filterBorder;
  position: relative;
  .filter-item {
    display: inline-block;
    margin-right: 15px;
    vertical-align: top;
    padding: 0em 0em 0em 0em;
    margin: 0em 0em 0em 0em;
    .v-text-field {
      padding: 0em 0em 0em 0em;
      margin: 0em 0em 0em 0em;
    }
  }
  & > .btn-filter {
    position: absolute;
    top: -8px;
    right: 0px;
  }
  & > .v-icon {
    display: inline-block;
    margin: 14px 5px 0 0;
  }
}
.style-1 {
  background-color: rgb(191, 255, 139);
}
#style-2 {
  background: #025a66e8;
  color: white;
}
#celda_especial {
  background: rgba(233, 252, 191, 0.822);
}
#celda_especial2 {
  background: rgba(202, 243, 243, 0.767);
}
#celda {
  background: rgba(158, 205, 241, 0.5);
}
#celda_roja {
  background: rgba(190, 9, 36, 0.3);
}
.filtrosActivoFijo {
  min-width: 100%;
  padding: 0em 0.5em 0em 0.5em;
}
.sinMargen {
  margin: 0em 0em 0em 0em;
  padding: 0em 0em 0em 0em;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/lista_personal_cas/Index.vue